export default {
  // Hero
  hero_title: "CATALOGO ATTREZZATURE PER COSTRUZIONE VERTICALE",
  hero_view_products: "Vedi Prodotti",
  hero_request_quote: "Richiedi Preventivo",

  // Products Section
  products_title: "Attrezzature ad Alte Prestazioni",
  product1_name: "Montacarichi a Cremagliera",
  product2_name: "Gru Rampante con Sistema di Sollevamento",

  // Specifications
  spec_work_height: "Altezza di Lavoro",
  spec_load_capacity: "Capacità di Carico",
  spec_speed: "Velocità",
  spec_configuration: "Configurazione",
  spec_total_area: "Area Interna Totale",
  spec_floor_area: "Area del Piano",
  spec_volume: "Volume Approssimativo",
  spec_tower_height: "Altezza della Torre",
  spec_service_height: "Altezza di Servizio",
  spec_max_capacity: "Capacità Massima",
  spec_steel_cables: "Cavi d'Acciaio",

  // Product Details
  product1_safety_title: "Caratteristiche di Sicurezza",
  product1_safety_desc: "Sistema senza cancello",
  product2_accessories_title: "Accessori Inclusi",
  product2_accessories_desc: "Forche per carichi fino a 2.000 kg + Secchio per calcestruzzo",

  // Video Section
  video_title: "Guarda le Attrezzature in Funzione",

  // Conditions
  conditions_delivery_title: 'Condizioni di Consegna e Pagamento',
  conditions_delivery_subtitle: 'Informazioni su scadenze e logistica',
  conditions_shipping_title: 'Previsione di Spedizione',
  conditions_shipping_desc: '30 giorni dopo la conferma dell\'ordine',
  conditions_delivery_card_title: 'Consegna',
  conditions_delivery_desc: '60 giorni dopo la spedizione (porto di destinazione)',
  conditions_packaging_title: 'Imballaggio',
  conditions_packaging_desc: 'Cassa di legno',
  conditions_warranty_title: 'Garanzia',
  conditions_warranty_period: '1 anno fornita dal produttore',
  conditions_manufacturer_title: 'Produttore',

  // Contact
  contact_title: "Mettiti in Contatto",
  contact_schedule_title: "Programma una Riunione",
  contact_schedule_desc: "Parla con il nostro team tramite Microsoft Teams",
  contact_email_title: "Contattaci",
  contact_email_desc: "Invia un'email al nostro team commerciale",

  // Footer
  footer_description: "Attrezzature importate per costruzione verticale",
  footer_products: "Prodotti",
  footer_product1: "Montacarichi",
  footer_product2: "Gru Rampante",
  footer_info: "Informazioni",
  footer_about: "Chi Siamo",
  footer_warranty: "Garanzia",
  footer_delivery: "Consegna",
  footer_contact: "Contatto",
  footer_address: "R. Voluntários da Pátria, nº 2468 / 2490, 6º piano",
  footer_building: "Edificio Brasília Corporate",
  footer_hours: "Lunedì a venerdì, 08:30 alle 18:00 (GMT -03:00)",
  footer_rights: "© 2026 Moviis. Tutti i diritti riservati.",

  // Language Switcher
  language_select: "Seleziona lingua",

  share: {
    whatsappMessage: 'Ciao! Ecco il catalogo delle attrezzature per costruzioni verticali Moviis:',
    emailSubject: 'Catalogo Moviis — Attrezzature per Costruzioni Verticali',
    emailBody: 'Ciao! Ecco il catalogo delle attrezzature per costruzioni verticali Moviis:',
    whatsappTooltip: 'Condividi su WhatsApp',
    emailTooltip: 'Condividi via Email',
  },

  // Financial Summary
  financial_title: 'Riepilogo Finanziario',
  financial_subtitle: 'Valori e condizioni di pagamento',
  financial_total_label: 'Totale Ordine',
  financial_total_value: 'Su richiesta',
  financial_installment1_label: 'Rata 1',
  financial_installment1_desc: '30% per avviare la produzione',
  financial_installment1_value: 'Su richiesta',
  financial_installment2_label: 'Rata 2',
  financial_installment2_desc: 'Pagamento del prodotto per il rilascio della spedizione',
  financial_installment2_value: 'Su richiesta',
  financial_installment3_label: 'Rata 3 (Saldo)',
  financial_installment3_desc: 'Arrivo a destinazione (porto o aeroporto)',
  financial_installment3_value: 'Su richiesta',
  financial_invoice_date: 'Data: 4 febbraio 2026',
  financial_considerations_title: 'Considerazioni sulla Proposta',
  financial_considerations_subtitle: 'Termini e condizioni importanti',
  financial_validity_label: 'Validità della proposta:',
  financial_validity: '15 giorni',
  financial_shipping_label: 'Termine di spedizione:',
  financial_shipping: 'Le attrezzature devono essere spedite entro 3 mesi. Dopo questo periodo, il contratto sarà considerato non valido.',
  financial_observation_label: 'Nota:',
  financial_observation: 'Trattandosi dell\'importazione diretta di 10 attrezzature, qualsiasi sostituzione o inclusione di nuovi articoli comporterà un ricalcolo dei valori.',
  financial_assembly_label: 'Montaggio e manutenzione tecnica:',
  financial_assembly: 'Non inclusi (responsabilità dell\'acquirente).',

  // Action Buttons
  financial_btn_print: 'Stampa',
  financial_btn_pdf: 'Scarica PDF',
  financial_btn_whatsapp: 'Invia tramite WhatsApp',
  financial_btn_email: 'Invia tramite email',
};